module.exports = __webpack_public_path__ + "img/phb@2x.3d6db1bd.png";